import React from "react";

import UserManagement from "../../../../components/v2/Admin/UserManagement";
import AdminUsersService from "../../../../services/AdminUsersService";

export default function AdminUsers() {
  return <UserManagement service={AdminUsersService} resource="users" />;
}
